import { Box, ChakraProvider, Heading } from '@chakra-ui/react';
import React, { useState } from 'react';

import PartnerLayout from '../../components/layout';

import Footer from '../../components/layout/footer';
import FAQSection from '../../components/pricing-page/FAQSection';
import FeatureComparisonSection from '../../components/pricing-page/FeatureComparisonSection';
import GallerySection from '../../components/pricing-page/GallerySection';
import PlanColumns from '../../components/pricing-page/PlanColumns';
import ScheduleAMeetingSection from '../../components/pricing-page/ScheduleAMeetingSection';
import TabNav, { TabType } from '../../components/pricing-page/TabNav';
import { legacyTheme } from '../../themes/legacyTheme';

const Header = () => (
  <Heading
    width="100%"
    textAlign="center"
    fontSize={['2xl', '3xl', '4xl', '5xl']}
    pt="44"
    mb={['16', '20']}
    px={['10', '16', '32']}
  >
    Plans and Pricing
  </Heading>
);

const Pricing = () => {
  const [tab, setTab] = useState<TabType>('Membership');

  return (
    <PartnerLayout title="Pricing - Beacon 3D+">
      <ChakraProvider theme={legacyTheme}>
        <Box w="100%" mb={16}>
          <Header />
          <TabNav selectedTab={tab} onSelectTab={newTab => setTab(newTab)} />
          <PlanColumns selectedTab={tab} />
          <GallerySection tab={tab} />
          <FeatureComparisonSection />
          <ScheduleAMeetingSection />
          <FAQSection />
        </Box>
      </ChakraProvider>

      <Footer />
    </PartnerLayout>
  );
};

export default Pricing;
